import get from 'lodash/get';

export default (state: object) => {
  const zones = get(state, 'page.data.site.zones', {});
  return Object.keys(zones);
};
